import styled from 'styled-components';


export const Div = styled.div`
    width:600px;
    height: 500px;
    @media (max-width: 960px) {
       width: 100%;
       height: 100%;
       overflow: hidden;
       transform: translateZ(0);
       will-change: transform;
    }
`